<template>
    <div>
        <div class="searchInput">
            <Input v-model="searchValue" search enter-button placeholder="疾病名称" 
                @on-search="searchTemplate" />
        </div>

        <!-- 点击搜索框下的第二级别-->
        <div class="templatePoint" v-if="partsList">
            <span v-for="(item, index) in partsList" :class="[thisPart.id == item.id ? 'checkPart' : '', 'part']"
                @click="selectPart(item)">{{ item.title }}</span>
        </div>

        <!-- 折叠列表控件 -->
        <Collapse accordion @on-change="changeParts" v-model="collapseIndex">
            <Panel v-for="(i, index) in thirdList" :key="index" :name="JSON.stringify(index)">
                <span style="font-size:16px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;">{{ i.title }}</span>

                <!--  -->
                <div slot="content" v-show="templateShow" v-for="template in templateList">
                    <Poptip :class="[template.isNormal == 0 ? 'templatePopTipGood' : 'templatePopTipError', 'templatePopTip']"
                        :title="template.title" word-wrap width="350" trigger="hover" placement="left-start">
                        <div class="titlecontent" @click="checkTemplate(template)">{{ template.title }}</div>
                        <div class="content" style="padding:0;" slot="content">
                            <h3>影像学所见</h3>
                            <p>{{ template.description }}</p>
                            <h3>影像学提示</h3>
                            <p>{{ template.contents }}</p>
                        </div>
                    </Poptip>
                </div>
            </Panel>
        </Collapse>

    </div>
</template>

<script>
export default {
    props: ['partsList'],
    data() {
        return {
            thisPart: {
            },
            collapseIndex: "",
            thirdList: [],
            templateList: [],
            templateShow: false,
            searchValue: ""
        }
    },
    methods: {
        // 查询第二层

        selectPart(param) {
            // 有监控这个字段，一旦变化就立即重新查询
            this.thisPart = param
            this.collapseIndex = ""
        },

        // 查询第三层的列表
        searchThird(data) {
            if (data) {
                data.keywords = this.searchValue || ''
            }
            this.$api.data.findTemplateReport(data).then((res) => {
                this.thirdList = res.list
                this.collapseIndex = ""
            })
        },

        // 查询第四层的列表
        searchFourth(param) {
            this.templateShow = false
            this.$api.data.findTemplateReport(param).then((res) => {
                this.templateList = res.list
                this.templateShow = true
            })
        },
        // 方法传入的参数collapseindex是被点击的列表索引, 列表类型
        // 如果Collapse组件打开，则列表里有元素，如果关闭，则列表中没有元素
        changeParts(collapseindex) {
            // 组件打开
            if (collapseindex.length > 0) {
                let data = {
                    ownerId: this.thirdList[collapseindex[0]].id,
                    keywords: this.searchValue || ''
                }
                this.searchFourth(data)
            }
        },
        checkTemplate(param) {
            this.$emit('checkTemplate', param)
        },


        searchTemplate() {
            let data = {
                keywords: this.searchValue || ''
            }

            // 如果第四层的模板是展开状态
            if (this.collapseIndex.length > 0 && this.thirdList.length > 0) {
                data.ownerId = this.thirdList[this.collapseIndex[0]].id
                this.searchFourth(data)
            } 
            // 如果第四层的模板不是展开状态，仅更新第三层
            else {
                data.ownerId = this.thisPart.id
                this.searchThird(data)
            }

            
        },
    },
    watch: {
        // 监测第二层展示数据的变化，受到设备类型的影响
        partsList(newval, oldval) {
            this.thisPart = newval[0]
        },
        // 监测第二层选中的 thisPart 的变化
        thisPart(newval, oldval) {
            let data = {
                ownerId: newval.id,
            }
            this.searchThird(data)
        }
    },
    // 设备 > 系统(this.partsList) > 器官(this.thirdList) > 模板(this.templateList)
    mounted() {
        // 如果系统列表不为空，就搜索第一个部位下的模板
        if (this.partsList.length > 0) {
            this.thisPart = this.partsList[0]
        }
    }
}
</script>

<style lang="scss" scoped>
.searchInput {
    margin-bottom: 10px;
}

.templatePoint {
    width: 100%;
    padding: 0 5px;

    .part {
        height: 25px;
        text-align: center;
        padding: 5px;
        display: inline-block;
        font-size: 16px;
        margin: 1px 2px;
        line-height: 15px;
        cursor: pointer;

        &:hover {
            background: #5cadff;
        }
    }

    .checkPart {
        background: #2db7f5;
    }
}

.templatePopTipGood {
    border-left: 5px solid green;
    border-right: 5px solid green;

    &:hover {
        background: green;
        color: white;
    }
}

.templatePopTipError {
    border-left: 5px solid #ed4014;
    border-right: 5px solid #ed4014;

    &:hover {
        background: #ed4014;
        color: white;
    }
}

.templatePopTip {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-indent: 5px;
    border-bottom: 1px solid #dddddd;
    cursor: pointer;

    .content {
        color: black;
        // background: green;
    }

    .titlecontent {
        // width: 100%;
        width: 300px;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

// .templatePopTip{
//     width: 100%;
//     height: 30px;
//     line-height: 30px;
//     text-indent: 5px;
//     border-left: 5px solid orange;

//     border-right: 5px solid orange;
//     border-bottom: 1px solid #dddddd;
//     cursor: pointer;
//     &:hover{
//         background: orange;
//         color: white;
//     }
// }
.templateDetail {
    width: 100%;
    height: 34px;
    line-height: 34px;
    font-size: 18px;
    padding: 0 5px;
    cursor: pointer;
}</style>



// WEBPACK FOOTER //
// src/components/WriteHanding/PublicTemplate.vue